import { RemoteAccessInformation } from 'src/shared/models/address.model';

/**
 * Resolves the per-Pro remote access (e.g. Seam lock) credential from a job/address
 * payload. The backend serves this in two shapes:
 *
 *  - Legacy: a single `remote_access_information` object.
 *  - Current: an array of `{ homekeeper_job_id, remote_access_information }` entries,
 *    one per Pro on the job (team jobs have several). We must return the entry for the
 *    current Pro's homekeeper_job and never fall back to another Pro's code.
 *
 * Pass the raw value (`job.remote_access_information` or `address.remote_access_information`)
 * plus the current homekeeper_job id. Returns null when there is no code for this Pro.
 */
export function resolveRemoteAccessInformation(
  raw: any,
  homekeeperJobId?: number | string
): RemoteAccessInformation | null {
  if (!raw) {
    return null;
  }
  if (Array.isArray(raw)) {
    const entries = raw.filter(Boolean);
    if (homekeeperJobId != null) {
      const match = entries.find((entry) => `${entry?.homekeeper_job_id}` === `${homekeeperJobId}`);
      return match?.remote_access_information || null;
    }
    // No id to disambiguate: only safe when there is exactly one entry.
    return entries.length === 1 ? (entries[0]?.remote_access_information || null) : null;
  }
  return raw as RemoteAccessInformation;
}
